import { getLandingAll, getLandingAllHabilitadas, getLandingPaquete, postLandingNew, putLandingUpdate } from "../services/landingService"
import { deleteLanginPaquete, postLanginPaquete } from "../services/servicePaquete"

const dataInicial = {
    listLandingPage: [],
    listLandingPagePaquete: [],
    listLandingHabilitados: [],
    exito: 1,
    clavePaquete: '0',
    modal: false,
    actulizar: false,
    landingObj: {}
}

const GET_LANDING_ALL_ACTION = "GET_LANDING_ALL_ACTION"
const GET_LANDING_HABILITADOS_ACTION = "GET_LANDING_HABILITADOS_ACTION"
const GET_LANDING_PAQUETE_ACTION = "GET_LANDING_PAQUETE_ACTION"
const POST_LANDING_NEW_ACTION = "POST_LANDING_NEW_ACTION"
const PUT_LANDING_UPDATE_ACTION = "PUT_LANDING_UPDATE_ACTION"
const POST_LANDING_PAQUETE_ADD_ACTION = "POST_LANDING_PAQUETE_ADD_ACTION"
const DELETE_LANDING_PAQUETE_REMOVE_ACTION = "DELETE_LANDING_PAQUETE_REMOVE_ACTION"
const OPEN_LANDING_MODAL_ACTION = "OPEN_LANDING_MODAL_ACTION"
const CLOSE_LANDING_MODAL_ACTION = "CLOSE_LANDING_MODAL_ACTION"
const TARGET_LANDING_OBJETO_ACTION = "TARGET_LANDING_OBJETO_ACTION"
const ACTULIZAR_LANDING_ACTION = "ACTULIZAR_LANDING_ACTION"
export default function landingReducer(state = dataInicial, action) {
    switch (action.type) {
        case ACTULIZAR_LANDING_ACTION:
            return { ...state, actulizar: action.payload.actulizar }
        case TARGET_LANDING_OBJETO_ACTION:
            return { ...state, landingObj: action.payload.landingObj }
        case GET_LANDING_ALL_ACTION:
            return { ...state, listLandingPage: action.payload.listLandingPage }
        case GET_LANDING_HABILITADOS_ACTION:
            return { ...state, listLandingHabilitados: action.payload.listLandingHabilitados }
        case GET_LANDING_PAQUETE_ACTION:
            return { ...state, listLandingPagePaquete: action.payload.listLandingPagePaquete }
        case POST_LANDING_NEW_ACTION:
            return { ...state, exito: action.payload.exito }
        case PUT_LANDING_UPDATE_ACTION:
            return { ...state, exito: action.payload.exito }
        case POST_LANDING_PAQUETE_ADD_ACTION:
            return { ...state, exito: action.payload.exito }
        case DELETE_LANDING_PAQUETE_REMOVE_ACTION:
            return { ...state, expect: action.payload.exito }
        case OPEN_LANDING_MODAL_ACTION:
            return { ...state, clavePaquete: action.payload.clavePaquete, modal: action.payload.modal }
        case CLOSE_LANDING_MODAL_ACTION:
            return { ...state, clavePaquete: action.payload.clavePaquete, modal: action.payload.modal }
        default:
            return state
    }
}
export const actulizarlandingFormAction = ({actulizar}) => (dispatch) => {
    dispatch({
        type: ACTULIZAR_LANDING_ACTION,
        payload: {
            actulizar: actulizar
        }
    })
}
export const targetLandingObjetoAction = ({landing}) => (dispatch) => {
    dispatch({
        type: TARGET_LANDING_OBJETO_ACTION,
        payload: {
            landingObj: landing
        }
    })
}
export const obtenerLandingAllAction = () => async (dispatch) => {
    return await getLandingAll().then(Response => {
        dispatch({
            type: GET_LANDING_ALL_ACTION,
            payload: {
                listLandingPage: Response
            }
        })
        return Response
    }).catch(Error => {
        return []
    })
}
export const obtenerLandingHabilitadosAction = () => async (dispatch) => {
    return await getLandingAllHabilitadas().then(Response => {
        dispatch({
            type: GET_LANDING_HABILITADOS_ACTION,
            payload: {
                listLandingHabilitados: Response
            }
        })
        return Response
    }).catch(Error => {
        return []
    })
}
export const obtenerLandingPaqueteAction = ({ ClavePaquete }) => async (dispatch) => {
    return await getLandingPaquete({ ClavePaquete }).then(Response => {
        dispatch({
            type: GET_LANDING_PAQUETE_ACTION,
            payload: {
                listLandingPagePaquete: Response
            }
        })
        return Response
    }).catch(Error => {
        return []
    })
}
export const crearLandingAction = ({ Descripcion, Enlace, Nombre, Slug }) => async (dispatch) => {
    return await postLandingNew({ Descripcion, Enlace, Nombre, Slug }).then(Response => {
        dispatch({
            type: POST_LANDING_NEW_ACTION,
            payload: {
                exito: 1
            }
        })
        return Response
    }).catch(Error => {
        return Error
    })
}
export const actulizarLandingAction = ({ IdLanding, Estatus, Descripcion, Enlace, Nombre, Slug }) => async (dispatch) => {
    return await putLandingUpdate({ IdLanding, Estatus, Descripcion, Enlace, Nombre, Slug }).then(Response => {
        dispatch({
            type: PUT_LANDING_UPDATE_ACTION,
            payload: {
                exito: 1
            }
        })
        return Response
    }).catch(Error => {
        return Error
    })
}
export const asociarLandingPaqueteAction = ({ ClavePaquete, IdLanding }) => async (dispatch) => {
    return await postLanginPaquete({ ClavePaquete, IdLanding }).then(Response => {
        dispatch({
            type: POST_LANDING_PAQUETE_ADD_ACTION,
            payload: {
                exito: 1
            }
        })
        return Response
    }).catch(Error => {
        return Error
    })
}
export const eliminarLandingPaqueteAction = ({ IdPaqueteLanding }) => async (dispatch) => {
    return await deleteLanginPaquete({ IdPaqueteLanding }).then(Response => {
        dispatch({
            type: DELETE_LANDING_PAQUETE_REMOVE_ACTION,
            payload: {
                exito: 1
            }
        })
        return Response
    }).catch(Error => {
        return Error
    })
}
export const openModalLandingPaqueteAction = ({ clavePaquete }) => (dispatch) => {
    dispatch({
        type: OPEN_LANDING_MODAL_ACTION,
        payload: {
            modal: true,
            clavePaquete: clavePaquete
        }
    })
}
export const closeModalLandingPaqueteAction = () => (dispatch) => {
    dispatch({
        type: CLOSE_LANDING_MODAL_ACTION,
        payload: {
            modal: false,
            clavePaquete: '0'
        }
    })
}
